const RESERVATION_CONTACT_PHONE_PATTERN = /^1[3456789]\d{9}$/

export function normalizeReservationContact(value: null | number | string | undefined): string {
  return `${value ?? ""}`.trim()
}

export function isValidOptionalReservationContact(value: null | number | string | undefined): boolean {
  const contact = normalizeReservationContact(value)
  return !contact || RESERVATION_CONTACT_PHONE_PATTERN.test(contact)
}

export function getReservationSmsContactError(
  value: null | number | string | undefined,
): string | undefined {
  const contact = normalizeReservationContact(value)
  if (!contact) {
    return "请输入联系电话后再发送短信"
  }
  if (!RESERVATION_CONTACT_PHONE_PATTERN.test(contact)) {
    return "请输入正确的手机号"
  }
}

export function validateOptionalReservationContact(
  _rule: unknown,
  value: null | number | string | undefined,
  callback: (_error?: Error) => void,
) {
  if (isValidOptionalReservationContact(value)) {
    callback()
    return
  }

  callback(new Error("请输入正确的手机号"))
}
